



































































import {Vue, Component, Prop, Emit} from "vue-property-decorator";

@Component({})
export default class DashboardRecent extends Vue {
  @Prop({default: ""})
  title!: string;

  @Prop({default: []})
  value!: any[];

  @Prop({default: ""})
  ui!: string;

  @Prop({default: false})
  loading!: boolean;

  @Emit("reloadAction")
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  reloadAction() {}

  items = [
    {
      icon: true,
      title: "Jason Oner",
      avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
    },
    {title: "Travis Howard", avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"},
    {title: "Ali Connors", avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"},
    {title: "Cindy Baker", avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg"},
  ];
}
